<template>
  <f7-link class="wallet-chip display-inline-flex align-items-center gap-1" @click="$emit('click')">
    <f7-icon f7="wallet_fill" :size="12" />
    <span class="wallet-amount font-label-sm font-medium">{{ formatted }}</span>
  </f7-link>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  amount: { type: Number, default: 0 },
  currency: { type: String, default: 'CFA' },
})

defineEmits(['click'])

const formatted = computed(() => {
  return props.amount.toLocaleString('fr-FR') + ' ' + props.currency
})
</script>

<style scoped>
.wallet-chip {
  --f7-link-highlight-color: transparent;
  /* tonal chip that follows the bar ink — readable on light and dark navbars */
  background: color-mix(in srgb, var(--f7-on-surface, #1c1c1e) 8%, transparent);
  color: var(--f7-on-surface, #1c1c1e);
  border-radius: 14px;
  padding: 4px 10px;
}
.wallet-amount {
  letter-spacing: 0.02em;
}
</style>
